const noticeList = () => import('@/pages/device/notice/index.vue');
// const deviceDetail = () => import('@/pages/device/list/detail.vue');

export default [{
    path: '/device/notice',
    component: noticeList,
    meta: [{
        name: '设备管理'
    },
    {
        name: '配件通知管理',
        activeRoute: '/device/notice'
    }]
}];